module.exports = __webpack_public_path__ + "img/pen.dfaf11f9.png";